import React from 'react';
import RichMarkdown from './RichMarkdown';
import '../styles/ProjectDescription.css';

function ProjectDescription({ project }) {
    return (
        <div className="project-description">
            <div className="project-description-text">
                <RichMarkdown source={project.description || 'No description available.'} />
            </div>
        </div>
    );
}

export default ProjectDescription;
